export const PROFILE_PAGE_SIZE = 6

export const DEFAULT_PROFILE_FORM = {
  id: '',
  name: '',
  picture_url: '',
  channel_business_type: { id: 0, name: '' },
  channel_member_role: { id: 0, name: '' },
  channel_profile_connect: [
    {
      id: 0,
      name: '',
      logo_url: '',
      website_url: ''
    }
  ]
}

export const DEFAULT_PROFILE_SELECTION = {
  channel_profile: [
    {
      id: '',
      name: '',
      picture_url: '',
      channel_business_type: { id: 0, name: '' },
      channel_member_role: { id: 0, name: '' },
      channel_profile_connect: [
        { id: 0, name: '', logo_url: '', website_url: '' }
      ],
      other_business_type: ''
    }
  ],
  channel_profile_length: 0,
  total_channel_profile: 0
}
